var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_962_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_174_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_258_",
    d: "M9.75,11.38H1.62C0.73,11.38,0,10.65,0,9.75V1.63C0,0.73,0.73,0,1.62,0h8.12c0.9,0,1.62,0.73,1.62,1.62 v8.12C11.38,10.65,10.65,11.38,9.75,11.38z M1.62,1.63v8.12h8.13l0-8.12H1.62z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_170_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_255_",
    d: "M24.38,11.38h-8.12c-0.9,0-1.62-0.73-1.62-1.62V1.63c0-0.9,0.73-1.62,1.62-1.62h8.12 C25.27,0,26,0.73,26,1.63v8.12C26,10.65,25.27,11.38,24.38,11.38z M16.25,1.63v8.12h8.13l0-8.12H16.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_169_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_252_",
    d: "M9.75,26H1.62C0.73,26,0,25.27,0,24.38v-8.12c0-0.9,0.73-1.63,1.62-1.63h8.12c0.9,0,1.62,0.73,1.62,1.63 v8.12C11.38,25.27,10.65,26,9.75,26z M1.62,16.25v8.12h8.13l0-8.12H1.62z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_168_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_249_",
    d: "M24.38,26h-8.12c-0.9,0-1.62-0.73-1.62-1.62v-8.12c0-0.9,0.73-1.63,1.62-1.63h8.12 c0.9,0,1.62,0.73,1.62,1.63v8.12C26,25.27,25.27,26,24.38,26z M16.25,16.25v8.12h8.13l0-8.12H16.25z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiles);
export default __webpack_public_path__ + "static/media/Tiles.7ec102a9f1b91da00f17109d158c4c2d.svg";
export { ForwardRef as ReactComponent };